export default __webpack_public_path__ + "static/media/internet-plan.e73815f7.svg";